import { Box, Text } from '@factorialco/deprecated-design-system'

const DefaultDetailValue = ({
  description,
  value,
}: {
  description: string
  value?: string | number | null
}) =>
  value === undefined ? (
    <></>
  ) : (
    <Box minWidth="s240" flexNoShrink textAlign="left" gap="s8">
      <Text weight="medium" size="300" color="grey1000">
        {description}
      </Text>
      <Text weight="normal" size="300" color="grey800">
        {value}
      </Text>
    </Box>
  )

export interface DefaultPairTransactionDetailsProps {
  desc1: string
  desc2: string
  val1?: string | number | null
  val2?: string | number | null
}

export const DefaultPairTransactionDetails = ({
  desc1,
  desc2,
  val1,
  val2,
}: DefaultPairTransactionDetailsProps) => (
  <Box
    width="full"
    flexDirection="row"
    justifyContent="flexStart"
    alignItems="flexStart"
    flexWrap="wrap"
    gap="s32"
  >
    {desc1 && val1 && <DefaultDetailValue description={desc1} value={val1} />}
    {desc2 && val2 && <DefaultDetailValue description={desc2} value={val2} />}
  </Box>
)
